import {Component, HostBinding, OnInit} from '@angular/core';
import {GeneralService, SnackbarService} from 'app/core';
import {DeleteModalComponent} from 'app/components/delete-modal/delete-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {FeatureCreateCommand, FeaturesDataService} from 'app/domain/features/services/features.data.service';
import {Observable} from 'rxjs';
import {Location} from '@angular/common';

const FEATURES_BROWSER_URL = 'metadata/settings/features';

@Component({
    selector: 'pr-features-page',
    templateUrl: './features-page.component.html',
    styleUrls: ['./features-page.component.scss']
})
export class FeaturesPageComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    featureId: number;
    featureType: string;
    featureName: string;
    featurePossibleValues: string[];
    updatedAt: string;
    updatedByUserName: string;
    createdByUserName: string;

    isDeleting = false;
    isLoading = false;

    constructor(
        public featuresDataService: FeaturesDataService,
        public generalService: GeneralService,
        public snackbar: SnackbarService,
        private dialog: MatDialog,
        private router: Router,
        private _location: Location,
        private activatedRoute: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        this.featureId = this.activatedRoute.snapshot.params.id as number;
        const createObs: Observable<FeatureCreateCommand> = this.featuresDataService.getById(this.featureId);
        this.isLoading = true;
        createObs
            .subscribe(
                res => {
                    this.featureName = res.name;
                    this.featureType = res.type;
                    this.featurePossibleValues = res.possibleValues;
                    this.updatedAt = this.generalService.parseDateWithTime(res.updatedAt);
                    this.updatedByUserName = res.updatedByUserName;
                    this.createdByUserName = res.createdByUserName;
                },
                () => {
                    this.snackbar.info('Wystąpił błąd podczas pobierania danych.');
                    this._location.back();
                },
                () => {
                    this.isLoading = false;
                }
            );
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(DeleteModalComponent, {
            width: '250px',
            data: { name: this.featureName },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.deleted) {
                this.delete();
            }
        });
    }

    navToEdit(): void {
        this.router.navigateByUrl( FEATURES_BROWSER_URL + `/add/${this.featureId}`);
    }

    private delete() {
        this.isDeleting = true;
        this.featuresDataService.delete(this.featureId)
            .subscribe(
                res => this.deleted(res),
                err => this.deleteError(err),
                () => this.isDeleting = false
            );
    }



    private deleted(response): void {
        this.snackbar.info(`Cecha została usunięta.`);
        this.router.navigateByUrl(FEATURES_BROWSER_URL);
    }

    private deleteError(err: HttpErrorResponse) {
        this.isDeleting = false;
        if (err.status) {
            this.snackbar.info('Wystąpił błąd podczas usuwania.');
        }
    }

}
